






































































import Vue from 'vue';
import Component from 'vue-class-component';
import SearchIcon from 'vue-ionicons/dist/ios-search.vue';
import MenuIcon from 'vue-ionicons/dist/ios-menu.vue';
import MedellinFooter from '@/layouts/footers/MedellinFooter.vue';
import MedellinFooterBlue from '@/layouts/footers/MedellinFooterBlue.vue';

const mainLayoutProps = Vue.extend({
  props: {
    showElements: Boolean,
  },
});

@Component({
  components: {
    SearchIcon,
    MenuIcon,
    MedellinFooter,
    MedellinFooterBlue,
  },
})
export default class MainLayout extends mainLayoutProps {}
